import gql from 'graphql-tag';

/**
 * Data of the block project-power-company ("EVU"): the selected power company with the fields the
 * block shows, and the net registration requirements for the marker NA. Read through
 * `Project.blocks.powerCompany`, which checks the block's read permission.
 */
export const PROJECT_POWER_COMPANY_FIELDS = gql`
  fragment projectPowerCompanyFields on ProjectPowerCompanyBlock {
    id
    number
    powerCompany {
      _id
      company
      street
      zip
      city
      website
      description
    }
    netRegistrationRequirements {
      name
      fullfilledState
    }
  }
`;
